import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import { EmptyGuestyIntegration, IntegrationCompany, integrationsByCompany, LocalEditableIntegration } from "../../../Everou/_modelsTS/Integration";
import { CapsuleButton, MainPageWithButtons } from "../../../Everou/_components";
import { removeFromArr } from "../../../Common/_utils/utils";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Selectors } from "../../../Everou/_reducers/app.reducer";
import { PMSIntegrationsActions } from "../../_actions/PMSIntegrationsActions";
import { PMSGuestyIntegrationInput } from "../_components/PMSGuestyIntegrationInput";
import { AddIntegrationButton } from "../_components/AddIntegrationButton";
import { useAccountDraft } from "../_hooks/useAccountDraft";

export function PMSGuestyIntegration() {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    
    const serverIntegrations = useSelector(Selectors.getPMSIntegrationsInPanel);
    const accountDraft = useAccountDraft(IntegrationCompany.GUESTY);
    const serverEditableIntegrations = serverIntegrations.map(integration => ({ ...integration, editable: false }))

    const [integrationsLocal, setIntegrationsLocal ] = useState<LocalEditableIntegration[]>(
        () => integrationsByCompany(serverIntegrations, IntegrationCompany.GUESTY, accountDraft),
    );

    useEffect(() => {
        const updatedIntegrations = integrationsByCompany(serverIntegrations, IntegrationCompany.GUESTY, accountDraft);
        setIntegrationsLocal(updatedIntegrations);
    }, [serverIntegrations, accountDraft])

    const canAddOnMore = useMemo(() => integrationsLocal.length === 0 || !!integrationsLocal[integrationsLocal.length - 1].uid
    , [integrationsLocal])

    const addIntegration = useCallback(() => {
        if(canAddOnMore) {
            setIntegrationsLocal([...integrationsLocal, EmptyGuestyIntegration])
        }
    }, [canAddOnMore, integrationsLocal]);

    const onDeleteIntegration = (index: number) => {
        const integration = integrationsLocal[index];
        if(!integration.uid) {
            setIntegrationsLocal(removeFromArr<LocalEditableIntegration>(index, integrationsLocal))
        } else {
            dispatch(PMSIntegrationsActions.deleteIntegration(integration.uid))
            setIntegrationsLocal(removeFromArr<LocalEditableIntegration>(index, integrationsLocal))
        }
    }

    const toggleEditable = (index: number) => {
        const updatedIntegrations = integrationsLocal.map((integration, maxIndex) => index === maxIndex ? ({ ...integration, editable: !integration.editable}) : integration);
        setIntegrationsLocal(updatedIntegrations);
    }

    const onSetInitialStatus = (index: number) => {
        const updatedIntegrations = integrationsLocal.map((integration, maxIndex) => index === maxIndex ? serverEditableIntegrations[index] : integration)
        setIntegrationsLocal(updatedIntegrations)
    }

    const body = (
        <div className="c-grid c-grid--small rounded-bottom">
            {integrationsLocal.map((integration, index) => (
                <PMSGuestyIntegrationInput
                    key={integration.uid || "new"}
                    onSetInitialStatus={index => onSetInitialStatus(index)}
                    onDelete={index => onDeleteIntegration(index)}
                    index={index}
                    onToggleEditable={index => toggleEditable(index)}
                    integration={integration}
                />
            ))}
            
        </div>
    );

    return (
        <MainPageWithButtons
            //dataTestId={testIDs.root}
            pageTitle={t("mod_integrations_guesty_title")}
            content={body}
            buttons={[
                <AddIntegrationButton integrations={integrationsLocal} isEnabled={canAddOnMore} onClick={addIntegration} />,
            ]}
        />
    );
}

